var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPin = function SvgPin(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2301 14.1314L18.5001 12.0214C18.6274 11.9442 18.7359 11.8395 18.8177 11.7149C18.8994 11.5903 18.9522 11.4491 18.9723 11.3015C18.9925 11.1539 18.9794 11.0037 18.934 10.8618C18.8886 10.7199 18.8121 10.59 18.7101 10.4814L15.5001 7.27143C15.3915 7.16939 15.2616 7.09289 15.1197 7.04752C14.9778 7.00215 14.8276 6.98904 14.68 7.00917C14.5324 7.0293 14.3912 7.08214 14.2666 7.16385C14.1421 7.24556 14.0373 7.35406 13.9601 7.48143L11.8001 10.7114L7.31008 11.7114C7.2074 11.7363 7.11312 11.7879 7.03678 11.861C6.96044 11.934 6.90473 12.0259 6.87531 12.1274C6.84588 12.2289 6.84377 12.3363 6.86919 12.4389C6.89461 12.5414 6.94666 12.6354 7.02008 12.7114L13.1701 18.8714C13.2479 18.9419 13.3426 18.991 13.4451 19.0142C13.5475 19.0373 13.6541 19.0336 13.7547 19.0034C13.8552 18.9732 13.9463 18.9176 14.0191 18.842C14.0919 18.7663 14.1439 18.6731 14.1701 18.5714L15.2301 14.1314Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.09 15.8614L6 19.9814",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pin.9b93be52b8a57ff63990109c4557cc67.svg";